const SITE_URL = 'https://www.jonnycoe.com';
const SITE_NAME = 'Jonny Coe Photography';

export const personSchema = () => ({
  '@context': 'https://schema.org',
  '@type': 'Person',
  name: 'Jonny Coe',
  url: SITE_URL,
  image: `${SITE_URL}/og-default.jpg`,
  jobTitle: 'Climbing & Adventure Photographer',
  sameAs: [],
  knowsAbout: [
    'climbing photography',
    'alpine photography',
    'ski photography',
    'adventure photography',
    'expedition photography',
    'documentary photography',
  ],
});

export const organizationSchema = () => ({
  '@context': 'https://schema.org',
  '@type': 'ProfessionalService',
  name: SITE_NAME,
  url: SITE_URL,
  image: `${SITE_URL}/og-default.jpg`,
  sameAs: [],
  areaServed: [{ '@type': 'Place', name: 'Worldwide' }],
  priceRange: '$$$',
});

export const websiteSchema = () => ({
  '@context': 'https://schema.org',
  '@type': 'WebSite',
  name: SITE_NAME,
  url: SITE_URL,
});

export const breadcrumbSchema = (trail) => ({
  '@context': 'https://schema.org',
  '@type': 'BreadcrumbList',
  itemListElement: trail.map((item, i) => ({
    '@type': 'ListItem',
    position: i + 1,
    name: item.name,
    item: `${SITE_URL}${item.path}`,
  })),
});

export const imageGallerySchema = ({ name, description, path, images }) => ({
  '@context': 'https://schema.org',
  '@type': 'ImageGallery',
  name,
  description,
  url: `${SITE_URL}${path}`,
  author: { '@type': 'Person', name: 'Jonny Coe' },
  image: images.slice(0, 20).map((img) => ({
    '@type': 'ImageObject',
    contentUrl: img.src.startsWith('http') ? img.src : `${SITE_URL}${img.src}`,
    name: img.caption || name,
    description: img.caption || description,
    creator: { '@type': 'Person', name: 'Jonny Coe' },
    copyrightHolder: { '@type': 'Person', name: 'Jonny Coe' },
    copyrightNotice: `© ${new Date().getFullYear()} Jonny Coe`,
    creditText: 'Photo by Jonny Coe',
  })),
});

export const faqSchema = (faqs) => ({
  '@context': 'https://schema.org',
  '@type': 'FAQPage',
  mainEntity: faqs.map((f) => ({
    '@type': 'Question',
    name: f.question,
    acceptedAnswer: {
      '@type': 'Answer',
      text: f.answer,
    },
  })),
});
